import { combineReducers } from "redux";
import App from "./App";
import Theme from "./Theme";
import Auth from "./Auth";

//App Modules
import Client from './Client';
import Records from './InitFormReducer'
import CompanyReducer from "./CompanyReducer";
// import RecruitmentFormReducer from "./RecruitmentFormReducer";

//Admin modules
import Role from "./Role";
import User from "./User";
import Module from "./Module";
import RoleModule from "./RoleModule";

//Custom modules
import TableComponentReducer from "./TableComponentReducer";

const reducers = combineReducers({
  theme: Theme,
  auth: Auth,
  app: App,

  // App Modules
  clients: Client,
  records: Records,
  company: CompanyReducer,

  // Admin Modules
  roles: Role,
  users: User,
  modules: Module,
  roleModules: RoleModule,

  // Custom modules
  tableComponent: TableComponentReducer,
});

export default reducers;
